import React, {
  Children,
  useEffect,
  useState,
  ReactNode,
  useMemo,
} from 'react';
import CockpitManageApi from '@/fetch/bussiness/cockpitManage';
import {
  Menu,
  Col,
  Row,
  Checkbox,
  Button,
  Modal,
  Select,
  Flex,
  message,
} from 'antd';
import { HttpStatusCode } from '@/fetch/core/constant';
import { vehicleBoardColumns } from '../../utils/columns';
import type { TreeDataNode, TreeProps } from 'antd';
import { isEmpty } from '@/utils/util';
import { useSelector } from 'react-redux';
import './index.scss';
import { RootState } from '@/redux/store';

type MenuItem = {
  label: string | ReactNode;
  level: number;
  parentKey: string;
  key: string;
  children: any[];
  status: 'indeterminate' | 'checked' | 'unChecked';
  length?: number;
  disabled: boolean;
};

const SelectVehicle = ({
  selectedVehicle,
  isBindModalOpen,
  closeModal,
  cockpitNumber,
}: {
  selectedVehicle: any[];
  isBindModalOpen: boolean;
  closeModal: AnyFunc;
  cockpitNumber: string;
}) => {
  const fetchApi = new CockpitManageApi();
  const newCommon = useSelector((state: RootState) => state.newCommon);
  const [addVehicle, setAddVehicle] = useState<
    { vehicleName: string; isSelect: boolean }[]
  >([]);
  const [oldSelectVehicle, setOldSelectVehicle] = useState<
    { vehicleName: string; isSelect: boolean }[]
  >([]);
  const [curSelect, setCurSelect] = useState<any[]>([]);
  const [options, setOptions] = useState<any[]>([]);
  const [selectVehicleModal, setSelectVehicleModal] = useState<boolean>(false);
  const [openKeys, setOpenKeys] = useState<string[]>([]);
  const [teamVehicle, setTeamVehicle] = useState<any>();
  const [searchVal, setSearchVal] = useState<string>();
  const [allVehicle, setAllVehicle] = useState<any[]>([]);

  useEffect(() => {
    setOldSelectVehicle(
      selectedVehicle.map((val: string) => ({
        vehicleName: val,
        isSelect: true,
      }))
    );
  }, [selectedVehicle]);

  useEffect(() => {
    setTimeout(() => {
      const activeMenuNode = document.querySelector('.active');
      if (activeMenuNode) {
        activeMenuNode.scrollIntoView();
      }
    }, 1000);
  }, [searchVal]);

  const renderTitle = (text: string) => {
    return (
      <div className="bind-vehicle-title">
        <div className="icon"></div>
        <span>{text}</span>
      </div>
    );
  };
  //  outside
  const bindVehicle = async () => {
    const vehicleNameList: string[] = [];
    addVehicle.concat(oldSelectVehicle).forEach((v) => {
      if (v.isSelect) {
        vehicleNameList.push(v.vehicleName);
      }
    });
    const res = await fetchApi.bindVehicle({
      cockpitNumber: cockpitNumber,
      vehicleNameList: vehicleNameList,
    });
    if (res.code === HttpStatusCode.Success) {
      closeModal && closeModal();
    } else {
      message.error(res?.message || '绑定失败');
    }
  };
  /**
   * 绑定弹窗 车牌号前选择框的勾选或取消勾选
   * @param vehicleName
   * @param type
   */
  const handleSelect = (vehicleName: string, type: 'old' | 'new') => {
    if (type === 'old') {
      setOldSelectVehicle(
        oldSelectVehicle.map((item: any) => {
          if (item.vehicleName === vehicleName) {
            return {
              vehicleName: vehicleName,
              isSelect: !item.isSelect,
            };
          } else {
            return item;
          }
        })
      );
    } else {
      setAddVehicle(
        addVehicle.map((item: any) => {
          if (item.vehicleName === vehicleName) {
            return {
              vehicleName: vehicleName,
              isSelect: false,
            };
          } else {
            return item;
          }
        })
      );
    }
  };

  const formatVehicleData = (selected: any[], data: any[]) => {
    const city: any = {};
    const station: any = {};
    const vehicle: any = {};
    for (let item of data) {
      const _stationId = 'station_' + item.stationBaseId;
      const _cityId = 'city_' + item.cityId;
      const isSelect = selected.find((v) => v.vehicleName === item.vehicleName);

      const vehicleInfo = {
        pid: _stationId,
        label: item.vehicleName,
        key: item.vehicleName,
        level: 3,
        children: [],
        disabled: isSelect ? isSelect.disabled : false,
        status: isSelect ? 'checked' : 'unChecked',
      };
      vehicle[item.vehicleName] = vehicleInfo;
      let stationInfo = station[_stationId];
      let cityInfo = city[_cityId];
      if (!stationInfo) {
        stationInfo = {
          pid: _cityId,
          label: item.stationBaseName,
          key: _stationId,
          level: 2,
          children: [{ ...vehicleInfo }],
          disabled: vehicleInfo.disabled,
          status: vehicleInfo.status,
          length: 1,
          checkedLen: vehicleInfo.status === 'checked' ? 1 : 0,
        };
        station[_stationId] = stationInfo;
      } else if (
        stationInfo &&
        !stationInfo.children.find((val: any) => val === item.vehicleName)
      ) {
        const len = stationInfo.children.push(vehicleInfo);
        stationInfo.length = len;
        stationInfo.checkedLen = stationInfo.children.filter(
          (v: any) => v.status === 'checked'
        ).length;
        const disabledLen = stationInfo.children.filter(
          (v: any) => v.disabled
        ).length;
        stationInfo.status =
          stationInfo.checkedLen === 0
            ? 'unchecked'
            : stationInfo.checkedLen === len
            ? 'checked'
            : 'indeterminate';
        stationInfo.disabled = disabledLen === len;
      }

      if (!cityInfo) {
        cityInfo = {
          children: [stationInfo.key],
          key: _cityId,
          label: item.cityName,
          level: 1,
        };
        city[_cityId] = cityInfo;
      } else if (
        cityInfo &&
        !cityInfo.children.find((val: any) => val === _stationId)
      ) {
        cityInfo.children.push(stationInfo.key);
      }
    }
    Object.values(city).forEach((c: any) => {
      c.length = 0;
      c.checkedLen = 0;
      c.children = c.children.map((sKey: any) => {
        c.length = c.length + station[sKey].length;
        c.checkedLen = c.checkedLen + station[sKey].checkedLen;
        return station[sKey];
      });
      const disabledLen = c.children.filter((v: any) => v.disabled).length;
      c.disabled = disabledLen === c.length;
      c.status =
        c.checkedLen === 0
          ? 'unchecked'
          : c.checkedLen === c.length
          ? 'checked'
          : 'indeterminate';
    });
    setTeamVehicle(Object.values(city));
  };

  const formatOptions = (data: any[]) => {
    const optionSet = new Set();
    for (let item of data) {
      const _stationId = 'station_' + item.stationBaseId;
      const _cityId = 'city_' + item.cityId;
      optionSet.add(
        JSON.stringify({ label: item.vehicleName, value: item.vehicleName })
      );
      optionSet.add(
        JSON.stringify({ label: item.stationBaseName, value: _stationId })
      );
      optionSet.add(JSON.stringify({ label: item.cityName, value: _cityId }));
    }
    setOptions(Array.from(optionSet).map((item: any) => JSON.parse(item)));
    setAllVehicle(data);
  };

  const fetchTeamVehicleInfo = async () => {
    const selected = [
      ...oldSelectVehicle.map((val) => ({
        vehicleName: val.vehicleName,
        disabled: true,
      })),
      ...addVehicle.map((val) => ({
        vehicleName: val.vehicleName,
        disabled: true,
      })),
    ];
    const res = await fetchApi.getTeamVehicleInfo({
      cockpitTeamNumber: newCommon.cockpitTeamNumber,
    });
    if (res.code === HttpStatusCode.Success) {
      formatVehicleData(selected, res.data);
      formatOptions(res.data);
      setSelectVehicleModal(true);
    }
  };

  //   inside
  const handleAddVehicle = () => {
    setSelectVehicleModal(false);
    if (!isEmpty(curSelect)) {
      const curSelectVehicle: any[] = [];
      curSelect.forEach((v: any) => {
        if (v.search('_') === -1) {
          curSelectVehicle.push({
            vehicleName: v,
            isSelect: true,
          });
        }
      });
      setAddVehicle(addVehicle.concat(curSelectVehicle));
    }
    setCurSelect([]);
  };

  const onOpenChange = (keys: string[]) => {
    setOpenKeys(keys);
  };

  const handleCheckbox = (item: any) => {
    const old = [
      ...oldSelectVehicle.map((val) => ({
        vehicleName: val.vehicleName,
        disabled: true,
      })),
      ...addVehicle.map((val) => ({
        vehicleName: val.vehicleName,
        disabled: true,
      })),
    ];
    const _set = new Set(curSelect);
    if (item.children.length > 0) {
      if (item.status === 'checked') {
        item.children.forEach((v: any) => {
          if (v.children.length > 0) {
            v.children.forEach((l: any) => {
              _set.delete(l.key);
            });
          } else {
            _set.delete(v.key);
          }
        });
      } else {
        item.children.forEach((v: any) => {
          if (v.children.length > 0) {
            v.children.forEach((l: any) => {
              _set.add(l.key);
            });
          } else {
            _set.add(v.key);
          }
        });
      }
    } else {
      _set.has(item.key) ? _set.delete(item.key) : _set.add(item.key);
    }
    const arr = Array.from(_set);
    setCurSelect(arr);
    formatVehicleData(
      old.concat(
        arr.map((vehicle) => ({ vehicleName: vehicle, disabled: false }))
      ),
      allVehicle
    );
  };

  const onChange = (value: any) => {
    if (!value) {
      setSearchVal(value);
      setOpenKeys([]);
      return;
    }
    const list = value.split('_');

    let node;
    if (list[0] === 'station') {
      node = allVehicle?.find((v) => v.stationBaseId == list[1]);
      setOpenKeys(openKeys?.concat(['city_' + node?.cityId]));
    } else if (list[0] !== 'city') {
      node = allVehicle?.find((v) => v.vehicleName == list[0]);
      setOpenKeys(
        openKeys.concat([
          'city_' + node?.cityId,
          'station_' + node?.stationBaseId,
        ])
      );
    }
    setSearchVal(value);
  };

  /**
   * 绑定弹窗 清空已选
   */
  const clearSelectVehicle = () => {
    setOldSelectVehicle(
      oldSelectVehicle.map((v) => ({
        ...v,
        isSelect: false,
      }))
    );
  };

  const renderCheckbox = (item: any) => {
    return (
      <Checkbox
        key={item.key}
        onChange={(e) => {
          e.stopPropagation();
          handleCheckbox(item);
        }}
        indeterminate={item.status === 'indeterminate'}
        checked={item.status === 'checked'}
        disabled={item.disabled}
      >
        <span className={item.key === searchVal ? 'active' : 'notactive'}>
          {item.length ? `${item.label}(${item.length})` : item.label}
        </span>
      </Checkbox>
    );
  };

  const renderMenuList = (children: any[]) => {
    return children.map((item: MenuItem, index: number) => {
      const { label, level, parentKey, key, children } = item;
      if (level === 1) {
        return (
          <Menu.SubMenu
            className={`menu-item menu-level-${level}`}
            key={key}
            title={renderCheckbox(item)}
          >
            {renderMenuList(children)}
          </Menu.SubMenu>
        );
      } else if (level === 2) {
        return (
          <Menu.SubMenu
            className={`menu-item menu-level-${level}`}
            key={key}
            title={renderCheckbox(item)}
          >
            <Menu.Item
              className={`menu-item menu-level-${level}`}
              key={'vehicle' + item.key}
              style={{
                height: `${Math.ceil(children.length / 6) * 40}px`,
              }}
            >
              <Row>
                {children.map((val: any) => {
                  return <Col span={4}>{renderCheckbox(val)}</Col>;
                })}
              </Row>
            </Menu.Item>
          </Menu.SubMenu>
        );
      }
    });
  };

  return (
    <>
      <Modal
        title="绑定接管车辆"
        open={isBindModalOpen}
        onCancel={closeModal}
        width={1600}
        footer={[
          <Button key="add-vehicle" onClick={fetchTeamVehicleInfo}>
            添加绑定
          </Button>,
          <Button key="confirm-btn" type="primary" onClick={bindVehicle}>
            确定
          </Button>,
        ]}
      >
        <Row style={{ alignItems: 'center', marginBottom: '8px' }}>
          {renderTitle('已绑车辆')}
          <div className="clear-select-vehicle" onClick={clearSelectVehicle}>
            清空已选
          </div>
        </Row>

        <div
          style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}
        >
          {oldSelectVehicle.map((item: any) => {
            return (
              <Checkbox
                style={{ color: 'rgba(255,255,255,0.8)', marginRight: '25px' }}
                key={item.vehicleName}
                checked={item.isSelect}
                onChange={() => handleSelect(item.vehicleName, 'old')}
              >
                {item.vehicleName}
              </Checkbox>
            );
          })}
        </div>
        {renderTitle('新增车辆')}
        <div
          style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}
        >
          {addVehicle.map((item: any) => {
            return (
              <Checkbox
                style={{ marginLeft: '25px' }}
                key={item.vehicleName}
                defaultChecked={item.isSelect}
                onChange={() => handleSelect(item.vehicleName, 'new')}
              >
                {item.vehicleName}
              </Checkbox>
            );
          })}
        </div>
      </Modal>

      {selectVehicleModal && (
        <Modal
          title="添加绑定"
          open={selectVehicleModal}
          onCancel={() => setSelectVehicleModal(false)}
          width={1600}
          footer={[
            <Button key="back-btn" onClick={() => setSelectVehicleModal(false)}>
              返回
            </Button>,
            <Button key="confirm-add" type="primary" onClick={handleAddVehicle}>
              确定添加
            </Button>,
          ]}
        >
          <Flex className="select-vehicle-search" align="center">
            <span>城市/站点/车号</span>
            <Select
              options={options}
              showSearch={true}
              allowClear={true}
              filterOption={(value, option) => {
                return (
                  option?.value?.indexOf(value) > -1 ||
                  option?.label?.indexOf(value) > -1
                );
              }}
              placeholder={'请选择城市/站点/车号'}
              onChange={onChange}
            />
          </Flex>
          <Menu
            className="select-vehicle-container"
            openKeys={openKeys}
            mode="inline"
            theme="dark"
            onOpenChange={onOpenChange}
          >
            {renderMenuList(teamVehicle)}
          </Menu>
        </Modal>
      )}
    </>
  );
};

export default React.memo(SelectVehicle);
